import { cn } from "@/lib/utils";

export type DeploymentStatus =
  | "queued"
  | "building"
  | "ready"
  | "failed"
  | "stopped"
  | "cancelled"
  | "skipped";

const META: Record<DeploymentStatus, { label: string; dot: string; text: string; bg: string; ring: string; pulse: boolean }> = {
  queued:    { label: "Queued",    dot: "bg-muted-foreground",         text: "text-muted-foreground",  bg: "bg-subtle",         ring: "ring-border",         pulse: false },
  building:  { label: "Building",  dot: "bg-attention",                 text: "text-attention",          bg: "bg-attention-subtle",ring: "ring-attention/30",   pulse: true  },
  ready:     { label: "Ready",     dot: "bg-success",                   text: "text-success",            bg: "bg-success-subtle",  ring: "ring-success/30",     pulse: false },
  failed:    { label: "Failed",    dot: "bg-danger",                    text: "text-danger",             bg: "bg-danger-subtle",   ring: "ring-danger/30",      pulse: false },
  stopped:   { label: "Stopped",   dot: "bg-muted-foreground",          text: "text-muted-foreground",   bg: "bg-subtle",          ring: "ring-border",         pulse: false },
  cancelled: { label: "Cancelled", dot: "bg-muted-foreground",          text: "text-muted-foreground",   bg: "bg-subtle",          ring: "ring-border",         pulse: false },
  // T039 (US4): ignored-build-command returned exit 0; nothing rebuilt.
  skipped:   { label: "Skipped",   dot: "bg-accent",                    text: "text-accent",             bg: "bg-accent-subtle",   ring: "ring-accent/30",      pulse: false },
};

export function StatusPill({ status, size = "sm" }: { status: DeploymentStatus; size?: "xs" | "sm" }) {
  const m = META[status];
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full ring-1 leading-4 font-medium",
        size === "xs" ? "text-2xs px-1.5 py-px" : "text-xs px-2 py-0.5",
        m.bg, m.text, m.ring,
      )}
    >
      <span
        className={cn(
          "inline-block rounded-full",
          size === "xs" ? "h-1.5 w-1.5" : "h-2 w-2",
          m.dot,
          m.pulse && "animate-pulse-dot",
        )}
      />
      {m.label}
    </span>
  );
}
